import type { FC } from 'react';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { BiData, BiContextProvidedValue, UserNameClickBiEvent } from '@wix/da-bi/pkg/events';
import { ResourceType } from '@wix/da-shared-react/pkg/types/resource';
import UserGrid from '../../_partials/UserGrid/UserGrid';
import useModuleData from '@wix/da-gruser-shared/pkg/hooks/useModuleData';

interface Props {
  moduleId: number;
}

const Supporters: FC<Props> = ({ moduleId }) => {
  const logEvent = useBiLogger();

  const { moduleData } = useModuleData<any>(moduleId);

  const users = (moduleData.timePeriods?.recent?.results || []).map(supporter => supporter.user);

  return (
    <UserGrid
      users={users || []}
      onUserClick={user => {
        logEvent(
          BiData<UserNameClickBiEvent>({
            evid: 101,
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
            typeid: ResourceType.USER,
            itemid: user.userId,
          })
        );
      }}
    />
  );
};
Supporters.displayName = 'Supporters';

export default Supporters;
